import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ErrorInterceptor } from './modules/global/utils/error.interceptor';

export const INTERCEPTORS = [
  {
    provide: HTTP_INTERCEPTORS,
    useClass: ErrorInterceptor,
    multi: true
  },
];
